import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBracelet = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.5624 3.96742C19.8067 3.72313 19.8067 3.32741 19.5624 3.08312C19.3181 2.83883 18.9223 2.83883 18.6781 3.08312L16.3561 5.4047C16.1118 5.64894 16.1118 6.0447 16.3561 6.289C16.4782 6.41117 16.6383 6.4722 16.7983 6.4722C16.9583 6.4722 17.1183 6.41117 17.2404 6.289L17.9667 5.56288C19.7657 7.31505 20.7199 9.5266 20.7199 11.9703C20.7199 16.778 16.8084 20.6899 12 20.6899C7.19154 20.6899 3.28006 16.778 3.28006 11.9703C3.28006 9.5267 4.23424 7.31525 6.03315 5.56308L6.75917 6.28899C6.88134 6.41116 7.04135 6.4722 7.20137 6.4722C7.36138 6.4722 7.52134 6.41116 7.64352 6.289C7.88781 6.0447 7.88781 5.64894 7.64352 5.4047L5.32153 3.08312C5.07724 2.83883 4.68147 2.83883 4.43718 3.08312C4.19289 3.32741 4.19289 3.72313 4.43718 3.96742L5.12907 4.6592C3.11338 6.62983 2 9.21853 2 11.9704C2 17.484 6.48598 21.97 12 21.97C17.514 21.97 22 17.484 22 11.9704C22 9.21843 20.8866 6.62973 18.8708 4.659L19.5624 3.96742Z",
		fill: "currentColor"
	})
});
export default SvgBracelet;
